export default __webpack_public_path__ + "static/media/uploadCn2.a1736cae.jpg";